module.exports = __webpack_public_path__ + "static/bg.150fa882.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/bg.png
// module id = 140
// module chunks = 35783957827783 169310805621404